import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import Flex from 'styled-flex-component'

import { SideBarBlock } from '@components/UI/SideBar'
import { IApplicationState } from '@store'
import {
  fetchBrandFanGroups,
  fetchInfluencerIdentities,
  selectBrandFansStats,
} from '@store/brandFans'
import {
  selectBrandFanGroupsLink,
  selectInfluencerIdentitiesLink,
  selectInfluencerIdentityFilters,
} from '@store/me'
import BrandFansFiltersGroups from './Groups'
import BrandFansFiltersIdentity from './Identity'

const BrandFansFilters: React.FC = () => {
  const dispatch = useDispatch()
  const influencerIdentityFilters = useSelector((state: IApplicationState) =>
    selectInfluencerIdentityFilters(state),
  )
  const hasInfluencerIdentitiesLink = useSelector((state: IApplicationState) =>
    Boolean(selectInfluencerIdentitiesLink(state)),
  )
  const hasBrandFanGroupsLink = useSelector((state: IApplicationState) =>
    Boolean(selectBrandFanGroupsLink(state)),
  )
  const brandFansStats = useSelector((state: IApplicationState) => selectBrandFansStats(state))

  React.useEffect(() => {
    dispatch(fetchBrandFanGroups())
    dispatch(fetchInfluencerIdentities())
  }, [])

  const identityFilters = hasInfluencerIdentitiesLink ? influencerIdentityFilters : []
  return (
    <SideBarBlock
      header={
        <Flex justifyBetween alignCenter data-testid="filter-header-brand-fans">
          <FormattedMessage id="core.text.brandFans" />
        </Flex>
      }
      items={[
        ...identityFilters.map((filter: string) => (
          <BrandFansFiltersIdentity key={filter} filter={filter} stats={brandFansStats} />
        )),
        hasBrandFanGroupsLink && (
          <BrandFansFiltersGroups key="brand-fan-groups" stats={brandFansStats} />
        ),
      ]}
    />
  )
}

export { BrandFansFilters }
export default BrandFansFilters
